import React from 'react';

import {
  ButtonClose,
  ButtonEmpretec,
  Content,
  Header,
} from './modal-ddetail-style';

function HeaderDetail({
  moduleSelect,
  listEmpretecData,
  selectedId,
  handleSelect,
  closeModal,
  closeModalToSSubscription,
}) {
  return (
    <Header>
      <Content>
        {listEmpretecData.map((item) => {
          const isSelected = selectedId === item.id || moduleSelect === item.id;
          return (
            <ButtonEmpretec
              key={item.id}
              onClick={() => handleSelect(item.id)}
              bgColor={isSelected ? item.color : 'transparent'}
            >
              <img
                src={isSelected ? item.imgSelected : item.img}
                alt={`Logo ${item.id}`}
                style={{ height: 40 }}
              />
            </ButtonEmpretec>
          );
        })}
      </Content>

      {selectedId && (
        <ButtonClose
          bgColor={listEmpretecData.find((i) => i.id === selectedId)?.color}
          onClick={closeModal}
        >
          X
        </ButtonClose>
      )}
    </Header>
  );
}

export default HeaderDetail;
